import { load } from '@shopify/theme-sections'
import '../sections/faqs'

export default class FaqsSection {
  constructor () {
    load('faqs')
  }
}
